import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../css/ShowQuestion.css";
import questionsData from "../data/questions.json";
import axios from "axios";

const geminiApiKey = process.env.REACT_APP_GEMINI_API_KEY;
const geminiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${geminiApiKey}`;

const ShowQuestion = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const parsedId = parseInt(id);
  const rawQuestion = questionsData.find((q) => q.id === parsedId);
  const [resources, setResources] = useState([]);

  const image = location.state?.image || null;
  const question = rawQuestion ? { ...rawQuestion, image } : null;

  useEffect(() => {
    const fetchResources = async () => {
      if (!question) return;

      const prompt = `Please recommend only 3 helpful online learning resources enough with links for the topic: "${question.title}". Only return the titles and URLs in Markdown format.`;

      try {
        const response = await axios.post(geminiUrl, {
          contents: [{ parts: [{ text: prompt }] }],
        });

        const text = response.data.candidates?.[0]?.content?.parts?.[0]?.text || "";
        const matches = [...text.matchAll(/\[(.*?)\]\((.*?)\)/g)];
        const links = matches.map((match) => ({
          title: match[1],
          url: match[2],
        }));

        setResources(links);
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    };

    fetchResources();
  }, [question]);

  if (!question) {
    return <p>Question not found!</p>;
  }

  return (
    <div className="show-question">

      <div className="back-button-wrapper">
        <button className="back-button" onClick={() => navigate(-1)}>
          ＜ Back
        </button>
      </div>

      <h2>{question.title}</h2>

      {question.image && (
        <img
          src={question.image}
          alt={question.title}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      )}

      <p><strong>Author:</strong> {question.author}</p>
      <p><strong>Description:</strong> {question.description}</p>
      <pre><strong>Steps:</strong> {question.steps}</pre>

      {resources.length > 0 && (
        <div className="resources">
          <strong>Recommended Resources:</strong>
          <ul>
            {resources.map((res, index) => (
              <li key={index}>
                <a href={res.url} target="_blank" rel="noopener noreferrer">
                  {res.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ShowQuestion;
